import script from "./DicGroupDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DicGroupDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DicGroupDialog.vue?vue&type=style&index=0&id=6f102b05&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f102b05"]])

export default __exports__